import { render, staticRenderFns } from "./UiBreadcrumbs.vue?vue&type=template&id=7b5e9a7a&scoped=true&"
import script from "./UiBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./UiBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./UiBreadcrumbs.vue?vue&type=style&index=0&id=7b5e9a7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5e9a7a",
  null
  
)

export default component.exports